const zh = {
  translation: {
    nav: {
      home: '首页',
      category: '分类',
      about: '关于我们',
      search: '搜索漫画...',
    },
    home: {
      hero_title: '抖漫网页版 - 在线漫画免费阅读平台',
      hero_subtitle: '无需下载APP，海量漫画在线畅读。PC端、手机浏览器直接访问，随时随地免费看漫画',
      hero_cta: '开始阅读',
      hero_secondary: '查看分类',
      featured_title: '编辑推荐',
      featured_subtitle: '精选优质漫画，为你推荐不容错过的佳作',
      hot_title: '热门排行',
      hot_subtitle: '最受读者欢迎的漫画作品',
      latest_title: '最新更新',
      latest_subtitle: '热门连载漫画的最新章节',
      category_title: '漫画分类',
      category_subtitle: '按类型找到你喜欢的漫画',
      faq_title: '常见问题',
      faq_subtitle: '关于抖漫网页版的常见疑问解答',
      cta_title: '马上开启你的漫画之旅',
      cta_subtitle: '海量漫画资源，随时随地免费畅读',
      cta_button: '立即免费阅读',
      view_all: '查看全部',
      read_now: '立即阅读',
      chapter: '话',
      views: '阅读',
      rating: '分',
    },
    category: {
      title: '漫画分类',
      subtitle: '按类型浏览你喜欢的漫画',
      all: '全部',
      no_comics: '该分类暂无漫画',
      comic_count: '共 {{count}} 部漫画',
    },
    article: {
      breadcrumb_home: '首页',
      breadcrumb_category: '分类',
      author: '作者',
      status: '状态',
      category: '分类',
      chapters: '总章节',
      views: '总阅读',
      rating: '评分',
      tags: '标签',
      description: '作品简介',
      latest_chapters: '最新章节',
      read_first: '从第一话开始阅读',
      continue_reading: '继续阅读',
      related_comics: '相关推荐',
    },
    about: {
      title: '关于我们',
      subtitle: '了解抖漫网页版的故事',
      brand_title: '品牌故事',
      brand_content: '抖漫网页版成立于2020年，是一个专注于为漫画爱好者提供优质免费阅读体验的在线平台。我们相信，优秀的漫画作品应该被更多人看到，而不应该被设备和付费门槛所阻碍。经过多年的发展，抖漫网页版已经成长为国内领先的网页版漫画阅读平台，日活跃用户超过百万。',
      mission_title: '我们的使命',
      mission_content: '让每一个人都能随时随地享受漫画的乐趣。我们致力于打造最流畅、最全面的网页版漫画阅读体验，让漫画真正触手可及。',
      reputation_title: '用户口碑',
      stats_users: '累计用户',
      stats_comics: '收录漫画',
      stats_views: '总阅读量',
      stats_daily: '日活跃用户',
      contact_title: '联系我们',
      contact_subtitle: '有任何问题或建议，欢迎随时联系我们',
      address: '公司地址',
      address_value: '北京市海淀区中关村科技园',
      email: '电子邮箱',
      email_value: 'contact@douman.com',
      phone: '客服电话',
      phone_value: '400-888-8888',
      business_hours: '工作时间',
      business_hours_value: '周一至周五 9:00 - 18:00',
    },
    footer: {
      copyright: '© 2026 抖漫网页版 | 保留所有权利',
      privacy: '隐私政策',
      terms: '服务条款',
      sitemap: '网站地图',
      description: '抖漫网页版 - 在线漫画免费阅读平台，无需下载即可畅享海量漫画资源。',
    },
    common: {
      loading: '加载中...',
      error: '加载失败，请重试',
      retry: '重试',
      back_to_top: '回到顶部',
      scroll_top: '顶部',
    },
  },
};

export default zh;